import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Row,
  Col,
  Form,
  Button,
  Select,
  InputNumber,
  message,
  Typography,
  Popconfirm,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import CustomLoader from "../../components/CustomLoader";
import APICaller from "../../utils/APICaller";
import HandleSearch from "../../utils/CommonSearchComponent";
import { store } from "../../store";
import useCurrentPath, { paginationOptions } from "../../components/Constants";
import { selectedRowInfo } from "../../store/actions";
import { useLocation } from "react-router-dom";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
export default function Currency() {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = useCurrentPath();
  const [tableForm] = Form.useForm();
  const [form] = Form.useForm();

  let storeRole = useSelector((state) => state.auth.role);

  let storeToken = useSelector((state) => state.auth.accessToken);

  let storeLIUId = useSelector((state) => state.auth.lIUId);

  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn
  );

  // Initialize storeList with a default value
  const [storeList, setStoreList] = useState([]);
  const [data, setData] = useState([]);
  const storePagination = useSelector((state) => state.auth.pagination);
  const storeTotalCount = useSelector((state) => state.auth.totalCount);

  //Search Filter
  const { Search } = Input;
  const [searchText, setSearchText] = useState("");

  const [values, setValues] = useState({
    code: "",
    symbol_native: "",
    history: "",
    status: "",
    createdAt: "",
    updatedAt: "",
  });

  const [showLoader, setShowLoader] = useState(false);
  const [selectionType, setSelectionType] = useState("checkbox");

  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
  const [collapseClass, setCollapseClass] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [list, setList] = useState([]);

  const getCurrencyList = async (source = "", pagination = "") => {
    setShowLoader(true);

    const searchIn = location.pathname.replace("/", "");
    const callActionFrom = source ? source : "";
    setSelectedRowKeys([]);
    const allStates = {
      showLoader: showLoader,
      setShowLoader: setShowLoader,
      pagination: pagination
        ? pagination
        : { current: 1, page: 1, pageSize: 20 },
      setPagination: setPagination,
      list: list,
      setList: setList,
      fetchWithoutPagination: "yes",
    };

    await HandleSearch(
      storeRole,
      storeToken,
      storeLIUId,
      storeAccessTokenExpiresOn,

      searchIn,

      callActionFrom,
      allStates,
      ""
    );

    // Ensure storeList gets updated with the latest data
    const fetchedData = store.getState().auth.list[currentPath + "_info"];
    //const fetchedData = data ? decryptData(data) : [];

    setStoreList(fetchedData);

    // Update data state after fetching
    setData(fetchedData);
    setShowLoader(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      await getCurrencyList();
    };
    fetchData();
  }, [storeLIUId, storeRole, storeToken, location.pathname]);

  // Filter the storeList based on the searchText
  const searchFilterData =
    storeList &&
    storeList.filter((item) => {
      const code = item.code ? item.code.toLowerCase() : "";

      return code.includes(searchText.toLowerCase());
    });

  const columns = [],
    additionalColumns = [];

  if (storeRole !== process.env.REACT_APP_SROLE) {
    columns.push({
      title: "Sr. No.",
      dataIndex: "srno",
      width: "5%",
      render: (text, record, index) => index + 1,
    });
  }

  const commonColumns = [
    {
      title: "Currency Code",
      dataIndex: "code",
      width: "15%",
      editable: true,
      render: (text) => <>{text}</>,
      sorter: (a, b) => a.name.localeCompare(b.code),
    },
    {
      title: "Currency Symbol",
      dataIndex: "symbol_native",
      width: "15%",
      editable: true,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      width: "15%",
    },
  ];

  if (
    storeRole === process.env.REACT_APP_SROLE ||
    storeRole === process.env.REACT_APP_ADROLE
  ) {
    additionalColumns.push(
      {
        title: "Updated At",
        dataIndex: "updatedAt",
        width: "20%",
      },
      {
        title: "Action",
        dataIndex: "action",
        width: "20%",
        render: (_, record) => {
          const editable = isEditing(record);
          return editable ? (
            <span>
              <Typography.Link
                onClick={() => save(record.key)}
                style={{
                  marginRight: 8,
                }}
              >
                Save
              </Typography.Link>
              <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                <a>Cancel</a>
              </Popconfirm>
            </span>
          ) : (
            <Typography.Link
              disabled={editingKey !== ""}
              onClick={() => edit(record)}
            >
              Edit
            </Typography.Link>
          );
        },
      }
    );
  }
  columns.push(...commonColumns, ...additionalColumns);

  const mergedColumns =
    columns &&
    columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: "text",
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
        }),
      };
    });
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.key === editingKey;
  const edit = (record) => {
    tableForm.setFieldsValue({
      code: "",
      symbol_native: "",
      createdAt: "",
      updatedAt: "",
      ...record,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const save = async (key) => {
    try {
      const row = await tableForm.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);
      if (index > -1) {
        const item = newData[index];

        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        setEditingKey("");

        const endpoint = "/currency/" + key;
        const method = "PUT";
        const payload = {
          code: newData[index]?.code,
          symbol_native: newData[index]?.symbol_native,
          historySource: "backend",
          historyAction: "update",
          historyUserID: storeLIUId,
        };
        APICaller(
          storeRole,
          storeToken,
          endpoint,
          method,
          payload,
          storeAccessTokenExpiresOn
        )
          .then((response) => {
            message.success("Currency updated successfully.");
            tableForm.resetFields();
            getCurrencyList();
          })
          .catch((error) => {});
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      const selectedRowKeysChildInfoArr = selectedRows.map((row) => row.key);

      dispatch(
        selectedRowInfo({
          selectedRowKeysChildInfo: selectedRowKeysChildInfoArr,
        })
      );
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled User",
      name: record.name,
    }),
  };

  //Add Currency
  const onFinish = (currencyValues) => {
    setShowLoader(true);
    const endpoint = "/currency";
    const method = "POST";
    const payload = {
      auth: storeToken,
      code: currencyValues?.code,
      symbol_native: currencyValues?.symbol_native,
      createdAt: new Date().toISOString(),
      historySource: "backend",
      historyAction: "create",
      historyUserID: storeLIUId,
    };
    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn
    )
      .then((response) => {
        setCollapseClass("hide");
        message.success("Currency added successfully.");
        form.resetFields();
        getCurrencyList();
        setShowLoader(false);
      })
      .catch((error) => {
        setShowLoader(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    setShowLoader(false);
  };

  const handlePaginationChange = (page, pageSize) => {
    if (pageSize === storeTotalCount) {
      // Load all items
      getCurrencyList("pagination", { page: 1, pageSize: storeTotalCount });
    } else {
      // Regular pagination
      getCurrencyList("pagination", { page, pageSize });
    }
  };
  return (
    <>
      <div className="container">
        <div className="card bgi-no-repeat card-stretch gutter-b border-2 rounded-lg p-0">
          <div className="border-2 card-header p-5">
            <div className="align-items-center d-flex justify-content-between">
              <h3 className="card-title m-0 p-0 border-2 font-weight-bolder text-dark text-size-16">
                Currency
              </h3>
              <button
                className="btn font-size-lg font-weight-bold py-2 redbutton rounded-lg text-white collapsed"
                data-toggle="collapse"
                href="#currency"
                role="button"
                aria-expanded="false"
                aria-controls="collapseContent"
              >
                <i className="flaticon2-plus mr-2 text-white"></i> Add New
                Currency
              </button>
            </div>
          </div>

          {(storeRole === process.env.REACT_APP_SROLE ||
            storeRole === process.env.REACT_APP_ADROLE) && (
            <>
              {/**Add New Currency Start**/}
              <div id="currency" className="collapse p-3">
                <div className="border border-light-dark p-4 m-0">
                  <Form
                    layout="vertical"
                    autoComplete="off"
                    className="form-validation-start"
                    form={form}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                  >
                    <Row gutter={[24, 24]}>
                      <Col sm={12}>
                        <Form.Item
                          className="m-0"
                          label="Currency code"
                          name="code"
                          rules={[
                            {
                              required: true,
                              message: "Please select Currency code",
                            },
                          ]}
                        >
                          {/* <Select
                            className="h-45px rounded-md"
                            isclearable="true"
                            placeholder="Select currency"
                            status=""
                            value=""
                            options={temp}
                            filterOption={(input, option) =>
                              option.label
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          /> */}

                          <Input
                            placeholder="Enter the currency code"
                            className="form-control h-45px rounded-md"
                            onChange={(e) => {
                              setValues({
                                ...values,
                                code: e.target.value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col sm={12}>
                        <Form.Item
                          className="m-0"
                          label="Currency Symbol"
                          name="symbol_native"
                          rules={[
                            {
                              required: true,
                              message: "Please select Currency Symbol",
                            },
                          ]}
                        >
                          <Input
                            placeholder="Enter the currency symbol"
                            className="form-control h-45px rounded-md"
                            onChange={(e) => {
                              setValues({
                                ...values,
                                symbol_native: e.target.value,
                              });
                            }}
                          />
                        </Form.Item>
                      </Col>

                      <Col sm={24}>
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="btn font-size-lg font-weight-bold ml-auto d-block py-2 redbutton rounded-lg text-white h-auto"
                        >
                          Submit
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </div>
                <hr className="mt-10" />
              </div>
              {/**Add New Currency End**/}
            </>
          )}

          <div id="alltable-size">
            <CustomLoader showLoader={showLoader} />
            <Search
              className="table-search"
              placeholder="Search Currency Code.."
              onSearch={(value) => setSearchText(value)}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <Form form={tableForm} component={false}>
              <Table
                rowSelection={
                  storeRole !== process.env.REACT_APP_SROLE
                    ? ""
                    : {
                        type: selectionType,
                        ...rowSelection,
                      }
                }
                components={{
                  body: {
                    cell: EditableCell,
                  },
                }}
                bordered
                dataSource={searchFilterData}
                columns={mergedColumns}
                rowClassName="editable-row"
                pagination={{
                  current: storePagination && storePagination?.current || 1,
                  pageSize: storePagination && storePagination?.pageSize || 20,
                  total: storeTotalCount,
                  pageSizeOptions: paginationOptions(storeTotalCount),
                  showSizeChanger: true,
                  onChange: (page, pageSize) =>
                    handlePaginationChange(page, pageSize),

                  onShowSizeChange: (current, size) =>
                    handlePaginationChange(current, size),
                }}
              />
            </Form>
          </div>
        </div>
      </div>
    </>
  );
}
